// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ri-c";
export var backButton = "_ri-4";
export var backIcon = "_ri-5";
export var chevronShortcut = "_ri-6";
export var container = "_ri-1";
export var editor = "_ri-8";
export var editorWrapper = "_ri-7";
export var prefix = "_ri-2";
export var searchIcon = "_ri-3";
export var suffix = "_ri-9";
export var suffixContent = "_ri-a";
export var suffixText = "_ri-b";
export var wrapper = "_ri-0";